import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useAuth } from '../contexts/AuthContext';
import AdminRequestsTable from './AdminRequestsTable';
import UploadRequestForm from './UploadRequestForm';

const useStyles = makeStyles({
  root: {
    padding: '20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  content: {
    marginTop: '20px',
  },
});

export default function AdminRequests() {
  const classes = useStyles();
  const { user, logout } = useAuth();
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  if (!user) {
    return <Navigate to="/contribute" replace />;
  }

  const handleLogout = async () => {
    await logout();
  };

  const handleUploadSuccess = (result) => {
    // Return to table view
    setShowUploadForm(false);
    // Trigger table refresh
    setRefreshTrigger(prev => prev + 1);
  };

  const handleUploadCancel = () => {
    setShowUploadForm(false);
  };

  return (
    <div className={classes.root}>
      <Paper elevation={1} style={{ padding: '20px' }}>
        <div className={classes.header}>
          <Typography variant="h4" component="h1">
            Admin Panel - Requests Management
          </Typography>
          <Box display="flex" alignItems="center" gap="16px">
            <Typography variant="body2">
              Welcome, {user.username || user.name || 'Admin'}
            </Typography>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Box>
        </div>

        <div className={classes.content}>
          {showUploadForm ? (
            <div>
              <Button
                variant="text"
                onClick={() => setShowUploadForm(false)}
                style={{ marginBottom: '16px' }}
              >
                ← Back to Requests
              </Button>
              <UploadRequestForm
                onSuccess={handleUploadSuccess}
                onCancel={handleUploadCancel}
              />
            </div>
          ) : (
            <AdminRequestsTable
              onShowUploadForm={() => setShowUploadForm(true)}
              refreshTrigger={refreshTrigger}
            />
          )}
        </div>
      </Paper>
    </div>
  );
}